import React, {useEffect, useState} from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
} from '@mui/material';
import {t} from 'i18next';
import makeStyles from '@mui/styles/makeStyles';
import AgyleAccordion from '../../../components/ui/accordion/agyleAccordion';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import Formatter from '../../../util/formatter';
import {user} from '../../../store/reducers/user';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import Button from '@mui/material/Button';
import config from '../../../app/config';
import AgyleDatePicker from '../../../components/ui/fields/agyleDatePicker';
import Divider from '@mui/material/Divider';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import useDict from '../../../hooks/useDict';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import ObservationTable from '../../../components/observation/observationTable';
import {openPatientForm} from '../../../store/reducers/patientContext';

const useStyles = makeStyles((theme) => ({

    divider: {
        width: '100%',
        alignItems: 'center',
        margin: "5px",
    },

    textField: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    radio: {
        width: '100%',
        minWidth: '100%',
    },

    mandatory: {
        fontWeight: 'bold',
        color: '#e06666',
    },

    clearButton:{
        border: '1px solid #2180f7',
        height: '25px',
        placeSelf: "center",
    },

    error: {
        color: theme.palette.error.main,
    },

    linkInfo: {
        color: "#2180f7",
        textIndent: '10%',
        padding: '10px !important',
    },

}));

const FrailtySDECForm = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const [chosenObs, setChosenObs] = useState([]);

    //dicts
    const [accommodationType] = useDict('CgaAccommodationType');
    const [toiletLocation] = useDict('CgaToiletLocation');
    const [administeredMedication] = useDict('CgaAdministeredMedication');
    const [patientFalls] = useDict('CgaPatientFalls');
    const [bathroomLocation] = useDict('CgaBathroomLocation');
    const [livesWith] = useDict('CgaLivesWith');
    const [bedType] = useDict('CgaBedType');
    const [chairType] = useDict('CgaChairType');
    const [foodConsistency] = useDict('CgaFoodConsistency');
    const [fluids] = useDict('CgaFluids');

    const [accordionExpandedState, setAccordionExpandedState] = useState({
        visitInformation: true,
        lastingPowerOfAttorney: false,
        complaints: false,
        administration: false,
        falls: false,
        osteoporosis: false,
        moodAndMemory: false,
        socialHistory: false,
        mobilityAndTransfers: false,
        activitieOfDailyLiving: false,
        additionalInformation: false,
        communication: false,
        dietNutritionAndSwallowing: false,
        vitalObservation: false,
        physicalExamination: false,
        systems: false,
        problems: false,
    });

    const [frailtySDECForm, setFrailtySDECForm] = useState({
        attendanceDate: "",
        attendanceTime:  "",
        noOfEDAttendance: "",
        noOfEDAdmission: "",
        advancedCarePlan: "",
        assessmentInitiatedBy:  "",

        familyName:  "",
        firstName: "",
        middleNames:  "",
        gender:  "",
        nextOfKin: null,
        hospitalNumber:  "",
        nhsNumber: "",
        address:  "",
        postCode:  "",

        lastingPowerOfAttorney: "",
        lastingPowerOfAttorneyText: "",

        presentingComplaint: "",
        historyOfPresentingComplaint:  "",
        pastMedicalHistory: "",
        allergies:  "",
        medication: "",

        administrationChooseItem: null,
        administrationText: "",
        administrationConcordance: "",

        fallsNoInpastYear: null,
        descriptionOfFalls: "",

        symptoms: {
            dizziness: false,
            sweat: false,
            palpitations: false,
            loss: false,
        },

        osteoporosisHistoryOfFractures: "",

        riskFactors: "",
        patientOnBoneProtection: "",
        patientOnBoneProtectionText: "",

        patientRadioDetails: {
            historyOfFractures: false,
            riskFactors: false,
            notOnBone: false,
        },

        diagnosisOfDementia: "",
        furtherDetails: "",

        alertness:  "",
        alertnessScore: "",
        delirium4at: "",
        delirium4atScore:  "",
        attention:  "",
        attentionScore:  "",
        fluctuation:  "",
        fluctuationScore:  "",
        total:  "",

        delirium4atdropdown: "",
        mood: "",


        accomodation: null,
        accomodationText: "",
        stairs: "",
        toilet: null,
        bathroom: null,
        livesWith: null,
        socialHistoryText: "",

        lifeSpace: "",
        walkingAid: {
            none: false,
            stick: false,
            crutches: false,
            wheeled: false,
            ross: false,
            stand: false,
            hoist: false,
            bed: false,
        },
        bedType: null,
        equipment: "",
        bedTransferIssues: "",
        chairType: null,
        difficulties: "",
        toiletEquipment: "",

        carers: "",
        agency: "",
        washAndDressing: "",
        toiletingIncludingContinence: "",
        meals: "",
        shopping: "",
        domesticTasks: "",
        rolesAndOccupation: "",

        careLine: "",
        keySafe: "",
        code: "",
        pressureAreas: "",

        mattress: "",
        cushion: "",

        hearing: "",
        vision: "",
        speechAndLanguage: "",
        preferredMethodOfCommunication: "",

        height: "", //props.patientAddData?.other?.nutritionScreen[0]?.height ? props.patientAddData?.other?.nutritionScreen[0]?.height : "",
        weight: "", //props.patientAddData?.other?.nutritionScreen[0]?.weight ? props.patientAddData?.other?.nutritionScreen[0]?.weight : "",
        bmi: "", //props.patientAddData?.other?.nutritionScreen[0]?.bmi ? props.patientAddData?.other?.nutritionScreen[0]?.bmi : "",
        signsOfVisibleWeightLoss: "",
        reducedAppetite: "",
        reducedAppetiteText: "",
        reportedSwallowingDifficulty: "",
        reportedSwallowingDifficultyText: "",
        foodConsistency: null,
        fluids: null,

        heartRate: "",
        bloodPressure: "",
        pulseRate: "",
        respiratoryRate: "",
        spO2: "",
        inspiredO2: "",
        temperature: "",
        lyingDownBloodPressure: "",
        standingBloodPressure: "",
        bloodPressureSystolic: "",
        bloodPressureDiastolic: "",
        abbeyPainScale: "",

        physicalExamination: {
            jaundice: false,
            anaemia: false,
            clubbing: false,
            cyanosis: false,
            oedma: false,
            lyphadenopathy: false,
        },
        generalComments: "",

        cardiovascular: "",
        respiratoryText: "",
        gastrointestinalText: "",
        musculoskeletalText: "",
        neurologyText: "",
        bloodResultsText: "",

        patientsPerceivedProblems: "",
        carersPerceivedProblems: "",
        problemList: "",
        treatmentPlanCfs: "",
        treatmentPlanText: "",
    })

    useEffect(() => {
        if(props.data){
            setFrailtySDECForm(props.data)
        } else {
            setFrailtySDECForm({

                attendanceDate: props.patient?.admission?.startDate ? moment(props.patient.admission.startDate).format(config.defaultDateFormat) : null,
                attendanceTime: props.patient?.admission?.startDate ? moment(props.patient.admission.startDate).format(config.defaultDateTimeFormat) : null,
                noOfEDAttendance: "",
                noOfEDAdmission: "",
                advancedCarePlan: "",
                assessmentInitiatedBy: props.patient?.currentClinician?.__description ? props.patient?.currentClinician?.__description : "",

                familyName: props.patient?.patient?.familyName ? props.patient?.patient?.familyName : "",
                firstName: props.patient?.patient?.firstName ? props.patient.patient.firstName: "",
                middleNames: props.patient?.patient?.middleNames ? props.patient.patient.middleNames: "",
                gender: props.patient?.patient?.gender ? props.patient.patient.gender : "",
                nextOfKin:  (props.patient?.patient?.nextOfKins[0]?.relationship.__description ? props.patient?.patient?.nextOfKins[0]?.relationship.__description: "") +
                    (props.patient?.patient?.nextOfKins[0]?.familyName ? props.patient?.patient?.nextOfKins[0]?.familyName : "") +
                    (props.patient?.patient?.nextOfKins[0]?.firstName ? props.patient?.patient?.nextOfKins[0]?.firstName : ""),
                hospitalNumber:  props.patient?.patient?.hospitalNumber ? props.patient.patient.hospitalNumber: "",
                nhsNumber:  props.patient?.patient?.nhsNumber ? props.patient.patient.nhsNumber: "",
                address: props.patient?.patient?.addresses[0]?.addressLines ? props.patient?.patient?.addresses[0].addressLines.join(" ") : "",
                postCode: props.patient?.patient?.postalCode ? props.patient.patient.postalCode: "",

                lastingPowerOfAttorney: "",
                lastingPowerOfAttorneyText: "",

                presentingComplaint: "",
                historyOfPresentingComplaint: props.patient?.clerking?.historicPresentingComplaint ? props.patient?.clerking?.historicPresentingComplaint : props.patient?.studies?.seeAndTreat?.historyOfPresentingComplaint ? props.patient?.studies?.seeAndTreat?.historyOfPresentingComplaint : props.patient?.triage?.historicPresentingComplaint ? props.patient?.historicPresentingComplaint?.allergies : "",
                pastMedicalHistory: props.patient?.clerking?.pastMedicalHistory ? props.patient?.clerking?.pastMedicalHistory : props.patient?.studies?.seeAndTreat?.pastMedicalHistory ? props.patient?.studies?.seeAndTreat?.pastMedicalHistory : props.patient?.triage?.pastMedicalHistory ? props.patient?.triage?.pastMedicalHistory : "",
                allergies: props.patient?.clerking?.allergies ? props.patient?.clerking?.allergies : props.patient?.studies?.seeAndTreat?.allergiesAndReactions ? props.patient?.studies?.seeAndTreat?.allergiesAndReactions : props.patient?.triage?.allergies ? props.patient?.triage?.allergies : "",
                medication: "",

                administrationChooseItem: null,
                administrationText: "",
                administrationConcordance: "",

                fallsNoInpastYear: null,
                descriptionOfFalls: "",

                symptoms: {
                    dizziness: false,
                    sweat: false,
                    palpitations: false,
                    loss: false,
                },

                osteoporosisHistoryOfFractures: "",

                riskFactors: "",
                patientOnBoneProtection: "",
                patientOnBoneProtectionText: "",

                patientRadioDetails: {
                    historyOfFractures: false,
                    riskFactors: false,
                    notOnBone: false,
                },

                diagnosisOfDementia: "",
                furtherDetails: "",

                alertness: props.patient?.studies?.delirium?.list[0]?.values.cat1.text ? props.patient.studies.delirium.list[0].values.cat1.text : "",
                alertnessScore: props.patient?.studies?.delirium?.list[0]?.values.cat1.score ? props.patient.studies.delirium.list[0].values.cat1.score : "",
                delirium4at: props.patient?.studies?.delirium?.list[0]?.values.cat2.text ? props.patient.studies.delirium.list[0].values.cat2.text : "",
                delirium4atScore: props.patient?.studies?.delirium?.list[0]?.values.cat3.score ? props.patient.studies.delirium.list[0].values.cat2.score : "",
                attention: props.patient?.studies?.delirium?.list[0]?.values.cat3.text ? props.patient.studies.delirium.list[0].values.cat3.text : "",
                attentionScore: props.patient?.studies?.delirium?.list[0]?.values.cat3.score ? props.patient.studies.delirium.list[0].values.cat3.score : "",
                fluctuation: props.patient?.studies?.delirium?.list[0]?.values.cat4.text ? props.patient.studies.delirium.list[0].values.cat4.text : "",
                fluctuationScore: props.patient?.studies?.delirium?.list[0]?.values.cat4.score ? props.patient.studies.delirium.list[0].values.cat4.score : "",
                total: props.patient?.studies?.delirium?.list[0]?.totalScore ? props.patient.studies.delirium.list[0].totalScore : "",

                delirium4atdropdown: "",
                mood: "",


                accomodation: null,
                accomodationText: "",
                stairs: "",
                toilet: null,
                bathroom: null,
                livesWith: null,
                socialHistoryText: "",

                lifeSpace: "",
                walkingAid: {
                    none: false,
                    stick: false,
                    crutches: false,
                    wheeled: false,
                    ross: false,
                    stand: false,
                    hoist: false,
                    bed: false,
                },
                bedType: null,
                equipment: "",
                bedTransferIssues: "",
                chairType: null,
                difficulties: "",
                toiletEquipment: "",

                carers: "",
                agency: "",
                washAndDressing: "",
                toiletingIncludingContinence: "",
                meals: "",
                shopping: "",
                domesticTasks: "",
                rolesAndOccupation: "",

                careLine: "",
                keySafe: "",
                code: "",
                pressureAreas: "",

                mattress: "",
                cushion: "",

                hearing: "",
                vision: "",
                speechAndLanguage: "",
                preferredMethodOfCommunication: "",

                height: "", //props.patientAddData?.other?.nutritionScreen[0]?.height ? props.patientAddData?.other?.nutritionScreen[0]?.height : "",
                weight: "", //props.patientAddData?.other?.nutritionScreen[0]?.weight ? props.patientAddData?.other?.nutritionScreen[0]?.weight : "",
                bmi: "", //props.patientAddData?.other?.nutritionScreen[0]?.bmi ? props.patientAddData?.other?.nutritionScreen[0]?.bmi : "",
                signsOfVisibleWeightLoss: "",
                reducedAppetite: "",
                reducedAppetiteText: "",
                reportedSwallowingDifficulty: "",
                reportedSwallowingDifficultyText: "",
                foodConsistency: null,
                fluids: null,

                heartRate: "",
                bloodPressure: "",
                pulseRate: "",
                respiratoryRate: "",
                spO2: "",
                inspiredO2: "",
                temperature: "",
                lyingDownBloodPressure: "",
                standingBloodPressure: "",
                bloodPressureSystolic: "",
                bloodPressureDiastolic: "",
                abbeyPainScale: "",

                physicalExamination: {
                    jaundice: false,
                    anaemia: false,
                    clubbing: false,
                    cyanosis: false,
                    oedma: false,
                    lyphadenopathy: false,
                },
                generalComments: "",

                cardiovascular: "",
                respiratoryText: "",
                gastrointestinalText: "",
                musculoskeletalText: "",
                neurologyText: "",
                bloodResultsText: "",

                patientsPerceivedProblems: "",
                carersPerceivedProblems: "",
                problemList: "",
                treatmentPlanCfs: "",
                treatmentPlanText: "",

            })
        }
    },[])

    useEffect(() => {
        if (props.onSubmitFunction) {
            props.onSubmitFunction(handleSaveForm);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isSubmitDisabled() || props.disableSave);
        }
    }, [frailtySDECForm, userObject, props.disableSave]);

    const handleChangeRadio = (event) => {
        const {name, value} = event.target;
        setFrailtySDECForm(pr => ({
            ...pr,
                [name]:value
            }))
    };

    const handleChangeTextField = (event) => {
        const {name, value} = event.target;
        setFrailtySDECForm(pr => ({
            ...pr,
            [name]:value
        }))
    };

    const handleChangeBlockSwitch = (name) => {
        setFrailtySDECForm(pr => ({
            ...pr,
            [name]:!pr[name]
        }))
    };

    const handleChangeCheckbox = (event, objectKey) => {
        const {name, checked} = event.target;
        setFrailtySDECForm((pr) =>
            ({
                ...pr,
                [objectKey]: {
                    ...pr[objectKey],
                    [name]:checked
                }
            }));
    };

    const handleChangeAccordion = (param) => {
        setAccordionExpandedState((pr) =>
            ({
                ...pr,
                [param]:!pr[param]
            }));
    };

    const handleChangeNull = (name) => {
        setFrailtySDECForm(pr => ({
            ...pr,
            [name]: ""
        }));
    };

    const handleChange = (event) => {
        const {name, value} = event.target;
        setFrailtySDECForm(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeDict = (name, value) => {
        handleChange({target: {name, value}});
    };

    const isSubmitDisabled = () => {

        let submitDisabled = false;

        const requiredFields = [
            frailtySDECForm.attendanceDate,
            frailtySDECForm.attendanceTime,
            frailtySDECForm.noOfEDAttendance,
            frailtySDECForm.noOfEDAdmission,
            frailtySDECForm.advancedCarePlan,

            frailtySDECForm.familyName,
            frailtySDECForm.firstName,
            frailtySDECForm.gender,
            frailtySDECForm.nextOfKin,
            frailtySDECForm.hospitalNumber,
            frailtySDECForm.nhsNumber,
            frailtySDECForm.address,
            frailtySDECForm.postCode,

            frailtySDECForm.historyOfFractures,

            frailtySDECForm.diagnosisOfDementia,
            frailtySDECForm.furtherDetails,
            frailtySDECForm.delirium4at,
            // frailtySDECForm.delirium4atdropdown, // @FIXME @Maja - this field is not in the form
            frailtySDECForm.mood,

            frailtySDECForm.patientsPerceivedProblems,
            frailtySDECForm.carersPerceivedProblems,
            frailtySDECForm.problemList,
            // frailtySDECForm.treatmentPlanCfs, // @FIXME @Maja - this field is not in the form
            frailtySDECForm.treatmentPlanText,
        ];

        if (requiredFields.some(field => field === "")) {
            submitDisabled = true;
        }
        return submitDisabled;
    };

    const handleSaveForm = () => {
        const objectToSave = {
            ...frailtySDECForm,
            timeStamp: moment().toISOString(),
            by: tester,
        }
      let dataArray = [{
          name: "studies.frailtySDECForm",
          value: objectToSave,
      }]

        props.onChange(dataArray);
    };

    const renderFormLabel = (condition, labelKey) => (
        <FormLabel className={condition ? classes.label : classes.mandatory}>
            {t(labelKey)}{!condition && '*'}
        </FormLabel>
    );

    const buttons = () => {
        const buttons = [];

            buttons.push(
                <AgyleButton
                    variant="contained"
                    disabled={props.workflowDisabled}
                    style={{margin: '0px 5px 0px 5px'}}
                    onClick={() => dispatch(openPatientForm('abbeyPainScaleForm'))}
                >
                    {t('Open Abbey Pain Scale')}
                </AgyleButton>,
            )

        return buttons;
    }

    return (
            <>
                <AgyleAccordion
                    expanded={accordionExpandedState.visitInformation}
                    onChange={()=>handleChangeAccordion("visitInformation")}
                    label="Visit Information"
                >
                     <Grid container spacing={2}>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.attendanceDate, "Attendance Date")}
                        </Grid>
                        <Grid item xs={3}>
                            <AgyleDatePicker
                                type="date"
                                error={!frailtySDECForm.attendanceDate}
                                value={frailtySDECForm.attendanceDate}
                                onChange={(param) => {setFrailtySDECForm((pr) =>
                                    ({
                                    ...pr,
                                    attendanceDate: param
                                }))}}
                            />
                        </Grid>

                        <Grid item xs={2}></Grid>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.attendanceTime, "Attendance Time")}
                        </Grid>
                        <Grid item xs={3}>
                            <AgyleDatePicker
                                type="time"
                                error={!frailtySDECForm.attendanceTime}
                                value={frailtySDECForm.attendanceTime}
                                onChange={(param) => {setFrailtySDECForm((pr) =>
                                    ({
                                    ...pr,
                                    attendanceTime: param
                                }))}}
                            />
                        </Grid>

                        <Grid item xs={3.25}>
                            {renderFormLabel(frailtySDECForm.noOfEDAttendance, "No of ED attendance in the past year")}
                        </Grid>
                        <Grid item xs={8.75}>
                            <AgyleTextField
                                fullWidth
                                name="noOfEDAttendance"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.noOfEDAttendance}
                                variant="outlined"
                                error={!frailtySDECForm.noOfEDAttendance}
                            />
                        </Grid>

                        <Grid item xs={3.25}>
                            {renderFormLabel(frailtySDECForm.noOfEDAdmission, "No of ED admission in the past year")}
                        </Grid>
                        <Grid item xs={8.75}>
                            <AgyleTextField
                                fullWidth
                                name="noOfEDAdmission"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.noOfEDAdmission}
                                variant="outlined"
                                error={!frailtySDECForm.noOfEDAdmission}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.advancedCarePlan, "Advanced Care Plan")}
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="advancedCarePlan"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.advancedCarePlan}
                                    className={!frailtySDECForm.advancedCarePlan && classes.error}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio className={!frailtySDECForm.advancedCarePlan && classes.error}/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio className={!frailtySDECForm.advancedCarePlan && classes.error}/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("advancedCarePlan")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Assessment initiated by")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="assessmentInitiatedBy"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.assessmentInitiatedBy}
                                variant="outlined"
                                //error={!frailtySDECForm.assessmentInitiatedBy}
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.lastingPowerOfAttorney}
                    onChange={()=>handleChangeAccordion("lastingPowerOfAttorney")}
                    label="Lasting Power Of Attorney"
                >
                    <Grid container spacing={2}>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.lastingPowerOfAttorney, "Lasting Power Of Attorney")}
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="lastingPowerOfAttorney"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.lastingPowerOfAttorney}
                                    className={!frailtySDECForm.lastingPowerOfAttorney && classes.error}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio className={!frailtySDECForm.lastingPowerOfAttorney && classes.error}/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio className={!frailtySDECForm.lastingPowerOfAttorney && classes.error}/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("lastingPowerOfAttorney")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {frailtySDECForm.lastingPowerOfAttorney === "yes" && (
                            <>
                                <Grid item xs={12}>
                                    <AgyleTextField
                                        fullWidth
                                        name="lastingPowerOfAttorneyText"
                                        // className={classes.input}
                                        maxRows={25}
                                        label={t("Click or tap here to enter text")}
                                        multiline
                                        onChange={handleChangeTextField}
                                        value={frailtySDECForm.lastingPowerOfAttorneyText}
                                        variant="outlined"
                                        //error={!frailtySDECForm.middleNames}
                                    />
                                </Grid>
                            </>)}

                    </Grid>

                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.complaints}
                    onChange={()=>handleChangeAccordion("complaints")}
                    label="Complaints"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.presentingComplaint, "Presenting Complaint")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="presentingComplaint"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.presentingComplaint}
                                variant="outlined"
                                error={!frailtySDECForm.presentingComplaint}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.historyOfPresentingComplaint, "History Of Presenting Complaint")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="historyOfPresentingComplaint"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.historyOfPresentingComplaint}
                                variant="outlined"
                                error={!frailtySDECForm.historyOfPresentingComplaint}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.pastMedicalHistory, "Past Medical History")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="pastMedicalHistory"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.pastMedicalHistory}
                                variant="outlined"
                                error={!frailtySDECForm.pastMedicalHistory}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.allergies, "Allergies")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="allergies"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.allergies}
                                variant="outlined"
                                error={!frailtySDECForm.allergies}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.medication, "Medication")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="medication"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.medication}
                                variant="outlined"
                                error={!frailtySDECForm.medication}
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.administration}
                    onChange={()=>handleChangeAccordion("administration")}
                    label="Administration"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={6}>
                            <FormLabel className={classes.label}>{t("Administered medication?")}</FormLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('administrationChooseItem', val)}
                                options={administeredMedication}
                                value={frailtySDECForm.administrationChooseItem}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <AgyleTextField
                                fullWidth
                                name="administrationText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.administrationText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Concordance?")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="administrationConcordance"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.administrationConcordance}
                                variant="outlined"
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.falls}
                    onChange={()=>handleChangeAccordion("falls")}
                    label="Falls"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("No falls in past year")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('fallsNoInpastYear', val)}
                                options={patientFalls}
                                value={frailtySDECForm.fallsNoInpastYear}
                                getOptionLabel={option => option.description}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Description Of Falls")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="descriptionOfFalls"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.descriptionOfFalls}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Symptoms")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.dizziness}
                                        name="dizziness"
                                    />
                                }
                                label="Dizziness"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.sweat}
                                        name="sweat"
                                    />
                                }
                                label="Sweat"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.palpitations}
                                        name="palpitations"
                                    />
                                }
                                label="Palpitations"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "symptoms")}
                                        checked={frailtySDECForm.symptoms.loss}
                                        name="loss"
                                    />
                                }
                                label="Loss of consciousness"
                            />
                        </Grid>


                    </Grid>

                </AgyleAccordion>
                <AgyleAccordion
                    expanded={accordionExpandedState.osteoporosis}
                    onChange={()=>handleChangeAccordion("osteoporosis")}
                    label="Osteoporosis"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.osteoporosisHistoryOfFractures, "History Of Fractures")}
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="osteoporosisHistoryOfFractures"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.osteoporosisHistoryOfFractures}
                                variant="outlined"
                                error={!frailtySDECForm.osteoporosisHistoryOfFractures}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormLabel className={classes.label}>{t("Risk Factors")}</FormLabel>

                            <FormControl>
                                <RadioGroup
                                    row
                                    name="riskFactors"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.riskFactors}
                                >
                                    <FormControlLabel
                                        value="copd" control={<Radio/>} label={t('COPD')}
                                    />
                                    <FormControlLabel
                                        value="immobility" control={<Radio/>} label={t('Immobility')}
                                    />
                                    <FormControlLabel
                                        value="history" control={<Radio/>} label={t('History of falls')}
                                    />
                                    <FormControlLabel
                                        value="smoker" control={<Radio/>} label={t('Smoker')}
                                    />
                                    <FormControlLabel
                                        value="hypogonadism" control={<Radio/>} label={t('Hypogonadism')}
                                    />
                                    <FormControlLabel
                                        value="endocrine" control={<Radio/>} label={t('Endocrine conditions')}
                                    />
                                    <FormControlLabel
                                        value="malabsorption" control={<Radio/>} label={t('Malabsorption conditions')}
                                    />
                                    <FormControlLabel
                                        value="bmi" control={<Radio/>} label={t('BMI less than 18.5kg/m2')}
                                    />
                                    <FormControlLabel
                                        value="previousOsteoporotic" control={<Radio/>} label={t('Previous osteoporotic fragility fracture')}
                                    />
                                    <FormControlLabel
                                        value="parentalHip" control={<Radio/>} label={t('Parental hip fracture')}
                                    />
                                    <FormControlLabel
                                        value="oralCorticosteroids" control={<Radio/>} label={t('Frequent oral corticosteroids')}
                                    />
                                    <FormControlLabel
                                        value="alcohol" control={<Radio/>} label={t('Alcohol - over 14 units per week')}
                                    />
                                    <FormControlLabel
                                        value="chronicKidney" control={<Radio/>} label={t('Chronic kidney disease')}
                                    />
                                    <FormControlLabel
                                        value="chronicLiver" control={<Radio/>} label={t('Chronic liver failure')}
                                    />
                                    <FormControlLabel
                                        value="hypogonadismMenopause" control={<Radio/>} label={t('Hypogonadism including untreated premature menopause')}
                                    />
                                    <FormControlLabel
                                        value="rheumatoid" control={<Radio/>} label={t('Rheumatoid arthritis or other inflammatory arthropathies')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("riskFactors")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Divider className={classes.divider}/>

                        <Grid item xs={12} className={classes.linkInfo}>
                            <FormLabel style={{color: "#2180f7"}}>
                                {t("Further guidance for assessment and treatment of osteoporosis can be found at ")}
                                <a href="https://cks.nice.org.uk" style={{ color: "#2180f7", fontWeight: "bold"}}>
                                    www.cks.nice.org.uk
                                </a>
                            </FormLabel>
                        </Grid>

                        <Divider className={classes.divider}/>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Patient On Bone Protection")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="patientOnBoneProtection"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.patientOnBoneProtection}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("patientOnBoneProtection")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <AgyleTextField
                                fullWidth
                                name="patientOnBoneProtectionText"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.patientOnBoneProtectionText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "patientRadioDetails")}
                                        checked={frailtySDECForm.patientRadioDetails.historyOfFractures}
                                        name="historyOfFractures"
                                    />
                                }
                                label="Patient has history of fractures"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "patientRadioDetails")}
                                        checked={frailtySDECForm.patientRadioDetails.riskFactors}
                                        name="riskFactors"
                                    />
                                }
                                label="Risk factors present"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "patientRadioDetails")}
                                        checked={frailtySDECForm.patientRadioDetails.notOnBone}
                                        name="notOnBone"
                                    />
                                }
                                label="Patient not on bone protection"
                            />
                        </Grid>

                        <Grid item xs={12} className={classes.linkInfo}>
                            <FormLabel className={classes.linkInfo}>{t("Please check vitamin D and calcium levels")}</FormLabel>
                        </Grid>

                        <Grid item xs={12} className={classes.linkInfo}>
                            <FormLabel className={classes.linkInfo}>{t("Recommend Treatment: please consider cognition, life expectancy and side effects")}</FormLabel>
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.moodAndMemory}
                    onChange={()=>handleChangeAccordion("moodAndMemory")}
                    label="Mood and Memory"
                >
                    <Grid container spacing={2}>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.diagnosisOfDementia, "Diagnosis Of Dementia")}
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="diagnosisOfDementia"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.diagnosisOfDementia}
                                    className={!frailtySDECForm.diagnosisOfDementia && classes.error}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio className={!frailtySDECForm.diagnosisOfDementia && classes.error}/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio className={!frailtySDECForm.diagnosisOfDementia && classes.error}/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("diagnosisOfDementia")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.furtherDetails, "Further Details")}
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="furtherDetails"
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.furtherDetails}
                                variant="outlined"
                                error={!frailtySDECForm.furtherDetails}
                            />
                        </Grid>

                        <Divider className={classes.divider}/>

                        <Grid item xs={1}></Grid>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.alertness, "Alertness")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="alertness"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.alertness}
                                variant="outlined"
                                error={!frailtySDECForm.alertness}
                            />
                        </Grid>
                        {/*<Grid item xs={2}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="alertnessScore"*/}
                        {/*        maxRows={25}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.alertnessScore}*/}
                        {/*        variant="outlined"*/}
                        {/*        error={!frailtySDECForm.alertnessScore}*/}
                        {/*    />*/}
                        {/*</Grid>*/}


                        <Grid item xs={1}></Grid>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.delirium4at, "AMT4")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="delirium4at"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.delirium4at}
                                variant="outlined"
                                error={!frailtySDECForm.delirium4at}
                            />
                        </Grid>
                        {/*<Grid item xs={2}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="delirium4atScore"*/}
                        {/*        maxRows={25}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.delirium4atScore}*/}
                        {/*        variant="outlined"*/}
                        {/*        error={!frailtySDECForm.delirium4atScore}*/}
                        {/*    />*/}
                        {/*</Grid>*/}


                        <Grid item xs={1}>
                            <FormLabel>{t("4AT")}</FormLabel>
                        </Grid>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.attention, "Attention")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="attention"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.attention}
                                variant="outlined"
                                error={!frailtySDECForm.attention}
                            />
                        </Grid>
                        {/*<Grid item xs={2}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="attentionScore"*/}
                        {/*        maxRows={25}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.attentionScore}*/}
                        {/*        variant="outlined"*/}
                        {/*        error={!frailtySDECForm.attentionScore}*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        <Grid item xs={1}></Grid>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.fluctuation, "Fluctuation")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="fluctuation"
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.fluctuation}
                                variant="outlined"
                                error={!frailtySDECForm.fluctuation}
                            />
                        </Grid>
                        {/*<Grid item xs={2}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="fluctuationScore"*/}
                        {/*        maxRows={25}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.fluctuationScore}*/}
                        {/*        variant="outlined"*/}
                        {/*        error={!frailtySDECForm.fluctuationScore}*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        <Grid item xs={1}></Grid>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.total, "Total")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="total"
                                // className={classes.input}
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.total}
                                variant="outlined"
                                error={!frailtySDECForm.total}
                            />
                        </Grid>

                        <Divider className={classes.divider}/>

                        <Grid item xs={2}>
                            {renderFormLabel(frailtySDECForm.mood, "Mood")}
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="mood"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.mood}
                                variant="outlined"
                                error={!frailtySDECForm.mood}
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.socialHistory}
                    onChange={()=>handleChangeAccordion("socialHistory")}
                    label="Social History"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={6}>
                            <FormLabel className={classes.label}>{t("Accomodation")}</FormLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('accomodation', val)}
                                options={accommodationType}
                                value={frailtySDECForm.accomodation}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <AgyleTextField
                                fullWidth
                                name="accomodationText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.accomodationText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Stairs?")}</FormLabel>
                        </Grid>

                        <Grid item xs={10}>
                            <FormControl>

                                <RadioGroup
                                    row
                                    name="stairs"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.stairs}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <FormControlLabel
                                        value="lift"
                                        control={<Radio/>}
                                        label={t('Lift')}
                                    />
                                    <FormControlLabel
                                        value="stairlift"
                                        control={<Radio/>}
                                        label={t('Stairlift')}
                                    />
                                    <FormControlLabel
                                        value="bedDownstairs"
                                        control={<Radio/>}
                                        label={t('Bed downstairs')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("stairs")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={1}>
                            <FormLabel className={classes.label}>{t("Toilet")}</FormLabel>
                        </Grid>
                        <Grid item xs={5}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('toilet', val)}
                                options={toiletLocation}
                                value={frailtySDECForm.toilet}
                            />
                        </Grid>

                        <Grid item xs={1}>
                            <FormLabel className={classes.label}>{t("Bathroom")}</FormLabel>
                        </Grid>
                        <Grid item xs={5}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('bathroom', val)}
                                options={bathroomLocation}
                                value={frailtySDECForm.bathroom}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Lives with?")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('livesWith', val)}
                                options={livesWith}
                                value={frailtySDECForm.livesWith}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <AgyleTextField
                                fullWidth
                                name="socialHistoryText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.socialHistoryText}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.mobilityAndTransfers}
                    onChange={()=>handleChangeAccordion("mobilityAndTransfers")}
                    label="Mobility And Transfers"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Life space")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="lifeSpace"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.lifeSpace}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Walking aid")}</FormLabel>
                        </Grid>

                        <Grid item xs={9}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.none}
                                        name="none"
                                    />
                                }
                                label="None"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.stick}
                                        name="stick"
                                    />
                                }
                                label="Stick"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.crutches}
                                        name="crutches"
                                    />
                                }
                                label="Crutches"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.wheeled}
                                        name="wheeled"
                                    />
                                }
                                label="Wheeled Zimmer Frame/Walker"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.ross}
                                        name="ross"
                                    />
                                }
                                label="Ross Return/Sara Stedy"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.stand}
                                        name="stand"
                                    />
                                }
                                label="Stand aid"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.hoist}
                                        name="hoist"
                                    />
                                }
                                label="Hoist"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "walkingAid")}
                                        checked={frailtySDECForm.walkingAid.bed}
                                        name="bed"
                                    />
                                }
                                label="Bed Bound"
                            />

                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Bed type")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('bedType', val)}
                                options={bedType}
                                value={frailtySDECForm.bedType}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Equipment")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="equipment"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.equipment}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Bed transfer issues?")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="bedTransferIssues"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.bedTransferIssues}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Chair type")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('chairType', val)}
                                options={chairType}
                                value={frailtySDECForm.chairType}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Difficulties?")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="difficulties"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.difficulties}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Toilet equipment")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="toiletEquipment"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.toiletEquipment}
                                variant="outlined"
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.activitieOfDailyLiving}
                    onChange={()=>handleChangeAccordion("activitieOfDailyLiving")}
                    label="Activitie Of Daily Living"
                >

                    <Grid container spacing={2}>


                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Carers")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="carers"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.carers}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Agency")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="agency"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.agency}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Wash and dressing")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="washAndDressing"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.washAndDressing}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Toileting including continence")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="toiletingIncludingContinence"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.toiletingIncludingContinence}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Meals")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="meals"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.meals}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Shopping")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="shopping"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.shopping}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Domestic tasks")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="domesticTasks"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.domesticTasks}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Roles and occupation")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="rolesAndOccupation"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.rolesAndOccupation}
                                variant="outlined"
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.additionalInformation}
                    onChange={()=>handleChangeAccordion("additionalInformation")}
                    label="Additional Information"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Care line")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="careLine"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.careLine}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("careLine")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Key safe")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="keySafe"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.keySafe}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("keySafe")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Code")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="code"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.code}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Pressure areas")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="pressureAreas"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.pressureAreas}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Pressure care in situ:")}</FormLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Mattress")}</FormLabel>
                        </Grid>
                        <Grid item xs={8}>
                            <AgyleTextField
                                fullWidth
                                name="mattress"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.mattress}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}></Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Cushion")}</FormLabel>
                        </Grid>
                        <Grid item xs={8}>
                            <AgyleTextField
                                fullWidth
                                name="cushion"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.cushion}
                                variant="outlined"
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.communication}
                    onChange={()=>handleChangeAccordion("communication")}
                    label="Communication"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Hearing")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="hearing"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.hearing}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Vision")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="vision"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.vision}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Speech and language")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="speechAndLanguage"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.speechAndLanguage}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Preferred method of communication")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="preferredMethodOfCommunication"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.preferredMethodOfCommunication}
                                variant="outlined"
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.dietNutritionAndSwallowing}
                    onChange={()=>handleChangeAccordion("dietNutritionAndSwallowing")}
                    label="Diet, Nutrition And Swallowing"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Height")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="height"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.height}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Weight")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="weight"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.weight}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("BMI")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="bmi"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.bmi}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Signs of visible weight loss")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="signsOfVisibleWeightLoss"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.signsOfVisibleWeightLoss}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Reduced appetite?")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="reducedAppetite"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.reducedAppetite}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("reducedAppetite")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <AgyleTextField
                                fullWidth
                                name="reducedAppetiteText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.reducedAppetiteText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Reported swallowing difficulty")}</FormLabel>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="reportedSwallowingDifficulty"
                                    onChange={handleChangeRadio}
                                    value={frailtySDECForm.reportedSwallowingDifficulty}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio/>}
                                        label={t('Yes')}
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio/>}
                                        label={t('No')}
                                    />
                                    <Button className={classes.clearButton} onClick={() => handleChangeNull("reportedSwallowingDifficulty")}> CLEAR </Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <AgyleTextField
                                fullWidth
                                name="reportedSwallowingDifficultyText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.reportedSwallowingDifficultyText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Food consistency")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('foodConsistency', val)}
                                options={foodConsistency}
                                value={frailtySDECForm.foodConsistency}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <FormLabel className={classes.label}>{t("Fluids")}</FormLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleDictionaryField
                                onChange={(_e, val) => handleChangeDict('fluids', val)}
                                options={fluids}
                                value={frailtySDECForm.fluids}
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.vitalObservation}
                    onChange={()=>handleChangeAccordion("vitalObservation")}
                    label="Vital Observation"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={12}>
                            <ObservationTable patient={props.patient} chooseObs chosenObs={chosenObs} setChosenObs={setChosenObs} />
                        </Grid>

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Heart rate")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="heartRate"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.heartRate}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Blood pressure")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="bloodPressure"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.bloodPressure}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Pulse rate")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="pulseRate"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.pulseRate}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Respiratory rate")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="respiratoryRate"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.respiratoryRate}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("SPO2")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="spO2"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.spO2}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Inspired O2")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="inspiredO2"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.inspiredO2}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Temperature")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="temperature"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.temperature}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Lying down blood pressure")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="lyingDownBloodPressure"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.lyingDownBloodPressure}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Standing blood pressure")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="standingBloodPressure"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.standingBloodPressure}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Blood pressure systolic")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="bloodPressureSystolic"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.bloodPressureSystolic}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        {/*<Grid item xs={3}>*/}
                        {/*    <FormLabel className={classes.label}>{t("Blood pressure diastolic")}</FormLabel>*/}
                        {/*</Grid>*/}
                        {/*<Grid item xs={9}>*/}
                        {/*    <AgyleTextField*/}
                        {/*        fullWidth*/}
                        {/*        name="bloodPressureDiastolic"*/}
                        {/*        // className={classes.input}*/}
                        {/*        maxRows={25}*/}
                        {/*        label={t("Click or tap here to enter text")}*/}
                        {/*        multiline*/}
                        {/*        onChange={handleChangeTextField}*/}
                        {/*        value={frailtySDECForm.bloodPressureDiastolic}*/}
                        {/*        variant="outlined"*/}
                        {/*    />*/}
                        {/*</Grid>*/}

                        <Grid item xs={12}>
                            <div className={classes.center}> {buttons()} </div>
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.physicalExamination}
                    onChange={()=>handleChangeAccordion("physicalExamination")}
                    label="Physical Examination"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Physical examination")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.jaundice}
                                        name="jaundice"
                                    />
                                }
                                label="Jaundice"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.anaemia}
                                        name="anaemia"
                                    />
                                }
                                label="Anaemia"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.clubbing}
                                        name="clubbing"
                                    />
                                }
                                label="Clubbing"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.cyanosis}
                                        name="cyanosis"
                                    />
                                }
                                label="Cyanosis"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.oedma}
                                        name="oedma"
                                    />
                                }
                                label="Oedma"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event)=> handleChangeCheckbox(event, "physicalExamination")}
                                        checked={frailtySDECForm.physicalExamination.lyphadenopathy}
                                        name="lyphadenopathy"
                                    />
                                }
                                label="Lyphadenopathy"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("General comments")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="generalComments"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.generalComments}
                                variant="outlined"
                            />
                        </Grid>

                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.systems}
                    onChange={()=>handleChangeAccordion("systems")}
                    label="Systems"
                >

                    <Grid container spacing={2}>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Cardiovascular")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="cardiovascular"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.cardiovascular}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Respiratory")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="respiratoryText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.respiratoryText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Gastrointestinal")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="gastrointestinalText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.gastrointestinalText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Musculoskeletal")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="musculoskeletalText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.musculoskeletalText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Neurology")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="neurologyText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.neurologyText}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <FormLabel className={classes.label}>{t("Blood results")}</FormLabel>
                        </Grid>
                        <Grid item xs={10}>
                            <AgyleTextField
                                fullWidth
                                name="bloodResultsText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.bloodResultsText}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>

                </AgyleAccordion>

                <AgyleAccordion
                    expanded={accordionExpandedState.problems}
                    onChange={()=>handleChangeAccordion("problems")}
                    label="Problems"
                >

                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.patientsPerceivedProblems, "Patient's Perceived Problems")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="patientsPerceivedProblems"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.patientsPerceivedProblems}
                                variant="outlined"
                                error={!frailtySDECForm.patientsPerceivedProblems}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.carersPerceivedProblems, "Carer's Perceived Problems")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="carersPerceivedProblems"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.carersPerceivedProblems}
                                variant="outlined"
                                error={!frailtySDECForm.carersPerceivedProblems}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.problemList, "Problem List")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="problemList"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.problemList}
                                variant="outlined"
                                error={!frailtySDECForm.problemList}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {renderFormLabel(frailtySDECForm.treatmentPlanText, "Treatment Plan")}
                        </Grid>
                        <Grid item xs={9}>
                            <AgyleTextField
                                fullWidth
                                name="treatmentPlanText"
                                // className={classes.input}
                                maxRows={25}
                                label={t("Click or tap here to enter text")}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtySDECForm.treatmentPlanText}
                                variant="outlined"
                                error={!frailtySDECForm.treatmentPlanText}
                            />
                        </Grid>
                    </Grid>

                </AgyleAccordion>

            </>
        )
}

export default FrailtySDECForm;